import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const additionalChargeInvoiceStylesAdapter = getAdapter({ idFieldName: 'value' });

const additionalChargeInvoiceStylesSlice = createSlice({
  name: 'additionalChargeInvoiceStyles',
  initialState: additionalChargeInvoiceStylesAdapter.getInitialState(),
  reducers: {
    setAdditionalChargeInvoiceStyles: (state, { payload: { additionalChargeInvoiceStyles } }) => {
      additionalChargeInvoiceStylesAdapter.setAll(state, additionalChargeInvoiceStyles);
    },
  },
});

const selectors = additionalChargeInvoiceStylesAdapter
  .getSelectors(({ additionalChargeInvoiceStyles }) => additionalChargeInvoiceStyles);

export const getAdditionalChargeInvoiceStyles = (state) => selectors.selectAll(state);

export const {
  setAdditionalChargeInvoiceStyles,
} = additionalChargeInvoiceStylesSlice.actions;

export default additionalChargeInvoiceStylesSlice.reducer;
